import { format } from "date-fns";
import { toWords } from "number-to-words";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import AuthContext from "../../../../utils/secure-route/AuthContext";
import { useToastHandler } from "../../../common/ToastHandler";
import "./Cheque.css";
import useFormattingUtils from "../../../../context/useFormattingUtils";

const DEFAULT_POSITIONS = {
  CHEQUE: {
    width: "203",
    height: "104",
    name: { x: 100, y: 100 },
    amount: { x: 600, y: 100 },
    amountInWords: { x: 100, y: 150 },
    date: { x: 600, y: 50 },
    chequeNumber: { x: 600, y: 200 },
    signature: { x: 600, y: 200 },
    logo: { x: 10, y: 10 },
  },
  A4: {
    width: "210",
    height: "297",
    name: { x: 150, y: 150 },
    amount: { x: 700, y: 150 },
    amountInWords: { x: 150, y: 200 },
    date: { x: 700, y: 75 },
    chequeNumber: { x: 700, y: 250 },
    signature: { x: 700, y: 250 },
    logo: { x: 20, y: 20 },
  },
};

const testLayout2 = () => {
  const printWindow = window.open("", "_blank", "width=600,height=600");
  const content = document.querySelector(".cheque-preview").outerHTML;
  const styles = `
    <style>
      .cheque-preview {
        background: white;
        position: relative;
        margin: 20px auto;
      }
      .draggable-item {
        position: absolute;
      }
      img {
        object-fit: contain;
      }
    </style>
  `;

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        ${styles}
      </head>
      <body>
        ${content}
      </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.print();
};

export default function ChequePreview() {
  const location = useLocation();
  const navigate = useNavigate();
  const { formatCurrency, currency } = useFormattingUtils();
  const { name, amount, date, chequeNumber, cheque_no, bulkData, isBulkUpload, currency: chequeCurrency } =
    location.state || {};
  const dragItem = useRef(null);
  const dragOffset = useRef({ x: 0, y: 0 });
  const [finalAmtInWord, setFinalAmtInWord] = useState("");
  const [logo, setLogo] = useState(null);
  const [signature, setSignature] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [signatureFile, setSignatureFile] = useState(null);
  const [logoSize, setLogoSize] = useState({ width: 40, height: 40 });
  const { Post, Get, Patch, getAPI, Delete } = useApi();
  const { user } = useContext(AuthContext);
  const [currentBulkIndex, setCurrentBulkIndex] = useState(0);
  const [bulkPreviewMode, setBulkPreviewMode] = useState(false);
  const [currentChequeData, setCurrentChequeData] = useState({
    name,
    amount,
    date,
    chequeNumber: chequeNumber || cheque_no,
    currency: chequeCurrency || currency
  });

  let storeid = user.store;
  const { handleToast } = useToastHandler();


  function getCurrencyNames(currencyCode) {
    try {
      const formatter = new Intl.NumberFormat("en", {
        style: "currency",
        currency: currencyCode,
        currencyDisplay: "name",
      });

      const parts = formatter.formatToParts(1);
      const currencyPart = parts.find(p => p.type === "currency");
      if (!currencyPart) {
        return { main: "Currency", sub: "Subunit" };
      }
      const main = currencyPart.value;
      const sub =
        currencyCode === "INR"
          ? "Paise"
          : currencyCode === "USD"
            ? "Cents"
            : currencyCode === "GBP"
              ? "Pence"
              : "Subunit";

      return {
        main: toCamelCase(main),
        sub,
      };
    } catch {
      return { main: "Currency", sub: "Subunit" };
    }
  }


  useEffect(() => {
    if (isBulkUpload && bulkData) {
      setBulkPreviewMode(true);
      setCurrentChequeData(bulkData[currentBulkIndex]);
    } else {
      setCurrentChequeData({ name, amount, date, chequeNumber: chequeNumber || cheque_no, currency: chequeCurrency || currency });
    }
  }, [isBulkUpload, bulkData, currentBulkIndex, name, amount, date, chequeNumber, cheque_no]);

  const handleBulkNavigation = (direction) => {
    if (direction === "next" && currentBulkIndex < bulkData.length - 1) {
      setCurrentBulkIndex((prev) => prev + 1);
    } else if (direction === "prev" && currentBulkIndex > 0) {
      setCurrentBulkIndex((prev) => prev - 1);
    }
  };

  const testLayout = () => {
    const printWindow = window.open("", "_blank", "width=600,height=600");
    const styles = `
      <style>
        .cheque-preview {
          background: white;
          position: relative;
          margin: 20px auto;
          page-break-after: always;
          width: ${positions.width}mm;
          height: ${positions.height}mm;
        }
        .draggable-item {
          position: absolute;
        }
        img {
          object-fit: contain;
        }
        @media print {
          .cheque-preview {
            page-break-after: always;
          }
        }
      </style>
    `;

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          ${styles}
        </head>
        <body>
    `);

    if (bulkPreviewMode && bulkData) {
      bulkData.forEach((chequeData) => {
        const amountInWords = convertNumberToWords(chequeData.amount);
        printWindow.document.write(`
          <div class="cheque-preview">
            <div class="cheque-content" style="position: relative; width: 100%; height: 100%; overflow: hidden;">
              ${layoutSettings.name ? `<div class="draggable-item" style="position: absolute; left: ${positions.name.x}px; top: ${positions.name.y}px;">${chequeData.name}</div>` : ""}
              ${layoutSettings.amount ? `<div class="draggable-item" style="position: absolute; left: ${positions.amount.x}px; top: ${positions.amount.y}px;">${chequeData.amount}</div>` : ""}
              ${layoutSettings.amountInWords ? `<div class="draggable-item" style="position: absolute; left: ${positions.amountInWords.x}px; top: ${positions.amountInWords.y}px;">${amountInWords}</div>` : ""}
              ${layoutSettings.date ? `<div class="draggable-item" style="position: absolute; left: ${positions.date.x}px; top: ${positions.date.y}px;">${formatDate(chequeData.date, dateFormat)}</div>` : ""}
              ${layoutSettings.signature && signature ? `<div class="draggable-item" style="position: absolute; left: ${positions.signature.x}px; top: ${positions.signature.y}px;"><img src="${signature}" alt="Signature" style="width: ${signatureSize.width}px; height: ${signatureSize.height}px; object-fit: contain;" /></div>` : ""}
              ${layoutSettings.logo && logo ? `<div class="draggable-item" style="position: absolute; left: ${positions.logo.x}px; top: ${positions.logo.y}px;"><img src="${logo}" alt="Logo" style="width: ${logoSize.width}px; height: ${logoSize.height}px; object-fit: contain;" /></div>` : ""}
            </div>
          </div>
        `);
      });
    } else {
      const content = document.querySelector(".cheque-preview").outerHTML;
      printWindow.document.write(content);
    }

    printWindow.document.write("</body></html>");
    printWindow.document.close();
    setTimeout(() => {
      printWindow.print();
    }, 500);
  };

  const [signatureSize, setSignatureSize] = useState({ width: 100, height: 70 });
  const [uploadPreviews, setUploadPreviews] = useState({ logo: null, signature: null });
  const [layoutPreferences, setLayoutPreferences] = useState({
    savedLayouts: [],
    currentLayoutName: "",
    showButtonRow: false,
  });
  const [uploadErrors, setUploadErrors] = useState({ logo: "", signature: "" });
  const [setpreformValues, setPreForm] = useState({
    amtbeforedeci: localStorage.getItem("pre") || "",
    amtafterdeci: localStorage.getItem("post") || "",
  });
  const [layoutSettings, setLayoutSettings] = useState({
    name: true,
    amount: true,
    amountInWords: true,
    date: true,
    logo: true,
    signature: true,
  });
  const [dateFormat, setDateFormat] = useState("MM-dd-yyyy");
  const [selectedSize, setSelectedSize] = useState("CHEQUE");
  const [positions, setPositions] = useState(DEFAULT_POSITIONS.CHEQUE);

  const saveLayoutPreference = async () => {
    const layoutData = {
      store: storeid,
      name_x: positions.name.x,
      name_y: positions.name.y,
      amount_x: positions.amount.x,
      amount_y: positions.amount.y,
      date_x: positions.date.x,
      date_y: positions.date.y,
      digital_sign_x: positions.signature.x,
      digital_sign_y: positions.signature.y,
      amount_in_words_x: positions.amountInWords.x,
      amount_in_words_y: positions.amountInWords.y,
      logo_x: positions.logo.x,
      logo_y: positions.logo.y,
      layout_name: layoutPreferences.currentLayoutName || `Layout ${Date.now()}`,
      currency_first: setpreformValues.amtbeforedeci || "Dollar",
      currency_second: setpreformValues.amtafterdeci || "Cents",
      date_format: dateFormat,
      layout_settings: JSON.stringify(layoutSettings),
      pre_form_values: JSON.stringify({
        amtbeforedeci: setpreformValues.amtbeforedeci,
        amtafterdeci: setpreformValues.amtafterdeci,
      }),
    };

    try {
      const response = await Post("preferenceCompanyData", layoutData);
      setLayoutPreferences((prev) => ({
        ...prev,
        savedLayouts: [...prev.savedLayouts, response.data],
      }));
      handleToast({ type: "SUCCESS", message: 'Layout saved successfully!' });
    } catch (error) {
      console.error("Error saving layout:", error);
      handleToast({ type: "ERROR", message: 'Failed to save layout' });
    }
  };

  const loadSavedLayout = (layout) => {
    try {
      const newPositions = {
        width: layout.width || positions.width,
        height: layout.height || positions.height,
        name: { x: layout.name_x, y: layout.name_y },
        amount: { x: layout.amount_x, y: layout.amount_y },
        amountInWords: { x: layout.amount_in_words_x, y: layout.amount_in_words_y },
        date: { x: layout.date_x, y: layout.date_y },
        signature: { x: layout.digital_sign_x, y: layout.digital_sign_y },
        logo: { x: layout.logo_x, y: layout.logo_y },
        chequeNumber: { x: positions.chequeNumber.x, y: positions.chequeNumber.y },
      };

      setPositions(newPositions);
      const newPreFormValues = {
        amtbeforedeci: layout.currency_first || "Dollar",
        amtafterdeci: layout.currency_second || "Cents",
      };
      const newDateFormat = layout.date_format || "MM-dd-yyyy";
      setPreForm(newPreFormValues);
      setDateFormat(newDateFormat);
      localStorage.setItem("pre", newPreFormValues.amtbeforedeci);
      localStorage.setItem("post", newPreFormValues.amtafterdeci);
      setLayoutPreferences((prev) => ({ ...prev, currentLayoutName: layout.layout_name }));
    } catch (error) {
      console.error("Error loading layout:", error);
      handleToast({ type: "ERROR", message: 'Failed to load layout' });
    }
  };

  function toCamelCase(str) {
    return str
      .toLowerCase()
      .replace(/[^a-zA-Z0-9 ]/g, " ")
      .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) =>
        index === 0 ? match.toUpperCase() : match.toUpperCase()
      )
      .replace(/\s+/g, " ");
  }

  const printCheque = async () => {
    try {
      const payload = {
        store: storeid,
        cheque_no: chequeNumber,
        name: name,
        amount: amount.toString(),
        created_by: user.user_id,
      };

      Post("chequeData", payload);
      const printWindow = window.open("", "_blank", "width=600,height=600");
      const content = document.querySelector(".cheque-preview").outerHTML;
      printWindow.document.write(content);
      printWindow.document.close();
      printWindow.print();

      handleToast({ type: "SUCCESS", message: 'Cheque created and printed successfully' });
    } catch (error) {
      console.error("Error creating cheque:", error);
      handleToast({ type: "ERROR", message: 'Failed to create cheque' });
    }
  };

  const printAllCheques = async () => {
    const printWindow = window.open("", "_blank", "width=600,height=600");
    const styles = `
    <style>
      .cheque-preview {
        background: white;
        position: relative;
        margin: 20px auto;
        page-break-after: always;
        width: ${positions.width}mm;
        height: ${positions.height}mm;
      }
      .draggable-item {
        position: absolute;
      }
      img {
        object-fit: contain;
      }
      @media print {
        .cheque-preview {
          page-break-after: always;
        }
      }
    </style>
  `;

    printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        ${styles}
      </head>
      <body>
  `);

    for (const chequeData of bulkData) {
      try {
        const payload = {
          store: storeid,
          cheque_no: chequeData.chequeNumber,
          name: chequeData.name,
          amount: chequeData.amount.toString(),
          created_by: user.user_id,
        };

        await Post("chequeData", payload);
        const amountInWords = convertNumberToWords(
          chequeData.amount,
          chequeData.currency || chequeCurrency || currency
        );


        printWindow.document.write(`
        <div class="cheque-preview">
          <div class="cheque-content" style="position: relative; width: 100%; height: 100%; overflow: hidden;">
            ${layoutSettings.name ? `<div class="draggable-item" style="position: absolute; left: ${positions.name.x}px; top: ${positions.name.y}px;">${chequeData.name}</div>` : ''}
            ${layoutSettings.amount ? `<div class="draggable-item" style="position: absolute; left: ${positions.amount.x}px; top: ${positions.amount.y}px;">${chequeData.amount}</div>` : ''}
            ${layoutSettings.amountInWords ? `<div class="draggable-item" style="position: absolute; left: ${positions.amountInWords.x}px; top: ${positions.amountInWords.y}px;">${amountInWords}</div>` : ''}
            ${layoutSettings.date ? `<div class="draggable-item" style="position: absolute; left: ${positions.date.x}px; top: ${positions.date.y}px;">${formatDate(chequeData.date, dateFormat)}</div>` : ''}
            ${layoutSettings.signature && signature ? `<div class="draggable-item" style="position: absolute; left: ${positions.signature.x}px; top: ${positions.signature.y}px;"><img src="${signature}" alt="Signature" style="width: ${signatureSize.width}px; height: ${signatureSize.height}px; object-fit: contain;" /></div>` : ''}
            ${layoutSettings.logo && logo ? `<div class="draggable-item" style="position: absolute; left: ${positions.logo.x}px; top: ${positions.logo.y}px;"><img src="${logo}" alt="Logo" style="width: ${logoSize.width}px; height: ${logoSize.height}px; object-fit: contain;" /></div>` : ''}
          </div>
        </div>
      `);
      } catch (error) {
        console.error(`Error processing cheque for ${chequeData.name}:`, error);
        handleToast({ type: 'ERROR', message: `Failed to process cheque for ${chequeData.name}` });
      }
    }

    printWindow.document.write('</body></html>');
    printWindow.document.close();

    setTimeout(() => {
      printWindow.print();
      handleToast({ type: 'SUCCESS', message: "All cheques processed and printed successfully" });
    }, 1000);
  };

  const updateUserProfile = async () => {
    const formData = new FormData();

    if (logoFile) {
      formData.append("logo", logoFile);
    }
    if (signatureFile) {
      formData.append("digital_signature", signatureFile);
    }

    try {
      const response = await Patch("updateUserProfile", user.user_id, formData);
      handleToast({ type: 'SUCCESS', message: "Profile updated successfully" });
    } catch (error) {
      console.error("Error updating profile:", error);
      handleToast({ type: 'ERROR', message: error.response?.data?.message || "Failed to update profile" });
    }
  };

  const handleFileUpload = (event, type) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const imageUrl = e.target.result;

      if (type === "logo") {
        setLogo(imageUrl);
        setLogoFile(file);
        setUploadPreviews((prev) => ({
          ...prev,
          logo: { url: imageUrl, name: file.name },
        }));
      } else {
        setSignature(imageUrl);
        setSignatureFile(file);
        setUploadPreviews((prev) => ({
          ...prev,
          signature: { url: imageUrl, name: file.name },
        }));
      }
    };
    reader.readAsDataURL(file);
  };

  const handleRemoveFile = (type) => {
    if (type === "logo") {
      setLogo(null);
      setLogoFile(null);
      setLogoSize({ width: 50, height: 50 });
    } else {
      setSignature(null);
      setSignatureFile(null);
      setSignatureSize({ width: 50, height: 50 });
    }
    setUploadPreviews((prev) => ({ ...prev, [type]: null }));
    setUploadErrors((prev) => ({ ...prev, [type]: "" }));
  };

  const UploadPreview = ({ type }) => {
    const preview = uploadPreviews[type];
    const error = uploadErrors[type];

    return (
      <div className="upload-preview-container">
        <div className="upload-button-container">
          <input
            type="file"
            id={`${type}-upload`}
            accept="image/*"
            onChange={(e) => handleFileUpload(e, type)}
            style={{ display: "none" }}
          />
          <button
            className="cheque-modern-btn"
            onClick={() => document.getElementById(`${type}-upload`).click()}
          >
            {type === "logo" ? "Update Logo" : "Update Signature"}
          </button>
        </div>

        {error && <div className="upload-error">{error}</div>}

        {(preview || (type === "logo" ? logo : signature)) && (
          <div className="preview-box">
            <img
              src={preview?.url || (type === "logo" ? logo : signature)}
              alt={`${type} preview`}
              style={{
                margin: "0px",
                width: "50px",
                height: "50px",
                minWidth: "50px",
                minHeight: "50px",
                maxWidth: "50px",
                maxHeight: "50px",
                objectFit: "contain",
              }}
            />
            <div className="preview-info">
              <button
                className="cheque-modern-btn"
                onClick={() => handleRemoveFile(type)}
              >
                Remove
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPreForm((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleDeleteLayout = () => {
    const selectedLayout = layoutPreferences.savedLayouts.find(
      (layout) => layout.layout_name === layoutPreferences.currentLayoutName
    );

    if (selectedLayout) {
      const layoutId = selectedLayout.id;
      deleteLayout(layoutId);
    }
  };

  const deleteLayout = async (layoutId) => {
    try {
      await Delete(`preferenceCompanyData`, layoutId);
      setLayoutPreferences((prev) => ({
        ...prev,
        savedLayouts: prev.savedLayouts.filter((layout) => layout.id !== layoutId),
      }));
      setLayoutPreferences((prev) => ({ ...prev, currentLayoutName: "" }));
      handleToast({ type: "SUCCESS", message: "Layout deleted successfully!" });
    } catch (error) {
      console.error("Error deleting layout:", error);
      handleToast({ type: "ERROR", message: "Failed to delete layout" });
    }
  };

  //   function convertNumberToWords(number) {
  //     if (!number || isNaN(parseFloat(number))) {
  //       return "Zero";
  //     }

  //     const num = parseFloat(number);
  //     if (num === 0) {
  //       return "Zero";
  //     }

  //     const [integerPart, decimalPart] = num.toString().split(".");
  //     const integerValue = parseInt(integerPart) || 0;
  //     const decimalValue = decimalPart ? parseInt(decimalPart) : 0;

  //     let integerInWords = toWords(integerValue);
  //     let decimalInWords = decimalValue > 0 ? toWords(decimalValue) : "";

  //     // const preKey = setpreformValues.amtbeforedeci || "Dollar";
  //     // const postKey = setpreformValues.amtafterdeci || "Cents";
  //     const { main, sub } = getCurrencyNames(currency);

  //     // let result = `${integerInWords} ${preKey}`;
  //     // if (decimalInWords) {
  //     //   result += ` and ${decimalInWords} ${postKey}`;
  //     // }

  //     let result = `${integerInWords} ${main} `;

  // if (decimalInWords) {
  //   result += ` and ${decimalInWords} ${sub}`;
  // }

  // result += " Only";

  //     return toCamelCase(result);
  //   }

  function convertNumberToWords(number) {
    if (!number || isNaN(parseFloat(number))) return "Zero";

    const num = parseFloat(number);
    if (num === 0) return "Zero";

    const [integerPart, decimalPart] = num.toString().split(".");

    const integerValue = parseInt(integerPart) || 0;
    const decimalValue = decimalPart ? parseInt(decimalPart) : 0;

    const integerInWords = toWords(integerValue);
    const decimalInWords = decimalValue > 0 ? toWords(decimalValue) : "";

    // ✅ use cheque currency
    const activeCurrency = currentChequeData.currency || currency;
    const { main, sub } = getCurrencyNames(activeCurrency);

    let result = `${integerInWords} ${main}`;

    if (decimalInWords) {
      result += ` and ${decimalInWords} ${sub}`;
    }

    result += " Only";

    return toCamelCase(result);
  }



  const formatDate = (date, formatStr) => {
    if (!date) return "";
    return format(new Date(date), formatStr);
  };

  const handleDragStart = (e, item) => {
    const rect = e.target.getBoundingClientRect();
    dragOffset.current = {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    };
    dragItem.current = item;
    e.target.style.opacity = "0.5";
  };

  const handleDrag = (e) => {
    if (!dragItem.current) return;

    e.preventDefault();
    const chequeContent = document.querySelector(".cheque-content");
    const rect = chequeContent.getBoundingClientRect();

    const x = e.clientX - rect.left - dragOffset.current.x;
    const y = e.clientY - rect.top - dragOffset.current.y;

    setPositions((prev) => ({
      ...prev,
      [dragItem.current]: { x, y },
    }));
  };

  const handleDragEnd = (e) => {
    e.target.style.opacity = "1";
    dragItem.current = null;
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleSettingChange = (setting) => {
    setLayoutSettings((prev) => ({
      ...prev,
      [setting]: !prev[setting],
    }));
  };

  const handleSizeChange = (size) => {
    setSelectedSize(size);
    setPositions((prevPositions) => ({
      ...prevPositions,
      width: DEFAULT_POSITIONS[size].width,
      height: DEFAULT_POSITIONS[size].height,
    }));
  };

  const handleSizeInputChange = (dimension, value) => {
    setPositions((prev) => ({
      ...prev,
      [dimension]: value,
    }));
  };

  useEffect(() => {
    if (currentChequeData.amount) {
      setFinalAmtInWord(convertNumberToWords(currentChequeData.amount));
    }
  }, [currentChequeData.amount, setpreformValues]);

  useEffect(() => {
    const fetchSavedLayouts = async () => {
      try {
        const response = await Get("preferenceCompanyData");
        const layouts = Array.isArray(response.results) ? response.results : [];
        setLayoutPreferences((prev) => ({ ...prev, savedLayouts: layouts }));
      } catch (error) {
        console.error("Error fetching layouts:", error);
      }
    };

    fetchSavedLayouts();
  }, []);

  useEffect(() => {
    const fetchUpdatedProfile = async () => {
      try {
        const getResponse = await Get(`${getAPI("updateUserProfile")}${user.user_id}`);
        const logoPath = getResponse.logo;
        const signaturePath = getResponse.digital_signature;

        if (logoPath) {
          const fullLogoUrl = `${getAPI("path")}${logoPath}`;
          setLogo(fullLogoUrl);
          setLogoFile(getResponse.logo);
          setLogoSize({ width: getResponse.logo_width, height: getResponse.logo_height });
        }

        if (signaturePath) {
          const fullSignatureUrl = `${getAPI("path")}${signaturePath}`;
          setSignature(fullSignatureUrl);
          setSignatureFile(getResponse.digital_signature);
          setSignatureSize({ width: getResponse.digital_signature_width, height: getResponse.digital_signature_height });
        }
      } catch (error) {
        console.error("Profile fetch error:", error);
        handleToast({ type: "ERROR", message: 'Failed to fetch profile images' });
      }
    };

    fetchUpdatedProfile();
  }, [user.user_id]);

  return (
    <div className="responsive-box">
      {/* Professional Header */}
      <div className="cheque-header">
        <div className="header-left">
          <button className="back-button" onClick={handleBackClick}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        </div>
        <div className="header-center">
          <h1>Cheque Preview</h1>
        </div>
        <div className="header-right">
          <button className="save-print-button" onClick={printCheque}>
            Save & Print
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="cheque-main-content" style={{
        display: "grid",
        gridTemplateColumns: window.innerWidth > 1200 ? "280px 1fr 280px" : window.innerWidth > 768 ? "250px 1fr 250px" : "1fr",
        gridTemplateRows: window.innerWidth <= 768 ? "auto auto auto" : "1fr",
        gap: "20px",
        padding: "20px",
        minHeight: "calc(100vh - 120px)"
      }}>
        {/* Left Controls Panel */}
        <div className="left-controls-panel" style={{
          background: "#fff",
          border: "1px solid #e1e5e9",
          borderRadius: "12px",
          padding: window.innerWidth <= 768 ? "12px" : "16px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          height: "fit-content",
          order: window.innerWidth <= 768 ? 2 : 0
        }}>
          {/* Checkboxes */}
          <div className="checkboxes-section">
            <h4 style={{ margin: "0 0 12px 0", fontSize: "14px", fontWeight: "600" }}>Elements</h4>
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              {Object.entries(layoutSettings).map(([key, value]) => (
                <label key={key} style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "12px" }}>
                  <input
                    type="checkbox"
                    checked={value}
                    onChange={() => handleSettingChange(key)}
                    style={{ margin: 0 }}
                  />
                  <span>{key.charAt(0).toUpperCase() + key.slice(1)}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Layout Options Section */}


          {/* Dimensions and Type */}
          <div className="dimensions-section" style={{
            marginBottom: "20px",
            paddingBottom: "16px",
            borderBottom: "1px solid #e9ecef"
          }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              <div className="input-group">
                <label style={{ fontSize: "12px", fontWeight: "600", color: "#495057", marginBottom: "4px", display: "block" }}>Width (mm)</label>
                <input
                  type="number"
                  value={positions.width}
                  onChange={(e) => handleSizeInputChange("width", e.target.value)}
                  className="cheque-modern-input"
                  style={{ width: "100%", padding: "8px 12px", fontSize: "14px" }}
                />
              </div>
              <div className="input-group">
                <label style={{ fontSize: "12px", fontWeight: "600", color: "#495057", marginBottom: "4px", display: "block" }}>Height (mm)</label>
                <input
                  type="number"
                  value={positions.height}
                  onChange={(e) => handleSizeInputChange("height", e.target.value)}
                  className="cheque-modern-input"
                  style={{ width: "100%", padding: "8px 12px", fontSize: "14px" }}
                />
              </div>
            </div>

            <div className="type-buttons" style={{
              display: "flex",
              gap: "8px",
              marginTop: "12px"
            }}>
              <button
                className={`type-button ${selectedSize === "CHEQUE" ? "active" : ""}`}
                onClick={() => handleSizeChange("CHEQUE")}
                style={{
                  flex: 1,
                  padding: "8px 12px",
                  borderRadius: "6px",
                  border: "1px solid #e1e5e9",
                  background: selectedSize === "CHEQUE" ? "#4a5546" : "#fff",
                  color: selectedSize === "CHEQUE" ? "#fff" : "#495057",
                  fontSize: "12px",
                  fontWeight: "500",
                  cursor: "pointer"
                }}
              >
                Cheque
              </button>
              <button
                className={`type-button ${selectedSize === "A4" ? "active" : ""}`}
                onClick={() => handleSizeChange("A4")}
                style={{
                  flex: 1,
                  padding: "8px 12px",
                  borderRadius: "6px",
                  border: "1px solid #e1e5e9",
                  background: selectedSize === "A4" ? "#4a5546" : "#fff",
                  color: selectedSize === "A4" ? "#fff" : "#495057",
                  fontSize: "12px",
                  fontWeight: "500",
                  cursor: "pointer"
                }}
              >
                A4
              </button>
            </div>
          </div>


        </div>

        {/* Center - Cheque Preview */}
        <div className="cheque-preview-container" style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          padding: window.innerWidth <= 768 ? "10px" : "20px",
          order: window.innerWidth <= 768 ? 1 : 0,
          overflow: "auto"
        }}>
          <div
            className="cheque-preview"
            style={{
              width: `${positions.width}mm`,
              height: `${positions.height}mm`,
              position: "relative",
              background: "#fff",
              border: "2px solid #e1e5e9",
              borderRadius: "12px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
              overflow: "hidden"
            }}
          >
            <div
              className="cheque-content"
              onDragOver={(e) => e.preventDefault()}
              onDrop={handleDrag}
              style={{
                position: "relative",
                width: "100%",
                height: "100%",
                padding: "20px",
                background: "#fff"
              }}
            >
              {/* Payee Name */}
              {layoutSettings.name && (
                <div
                  className="draggable-item"
                  draggable
                  onDragStart={(e) => handleDragStart(e, "name")}
                  onDragEnd={handleDragEnd}
                  style={{
                    position: "absolute",
                    left: `${positions.name.x}px`,
                    top: `${positions.name.y}px`,
                    cursor: "move",
                    userSelect: "none",
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#222",
                    minWidth: "120px"
                  }}
                >
                  {currentChequeData.name}
                </div>
              )}

              {/* Amount */}
              {layoutSettings.amount && (
                <div
                  className="draggable-item"
                  draggable
                  onDragStart={(e) => handleDragStart(e, "amount")}
                  onDragEnd={handleDragEnd}
                  style={{
                    position: "absolute",
                    left: `${positions.amount.x}px`,
                    top: `${positions.amount.y}px`,
                    cursor: "move",
                    userSelect: "none",
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#222",
                    minWidth: "80px"
                  }}
                >
                  {formatCurrency(currentChequeData.amount)}
                </div>
              )}

              {/* Amount in Words */}
              {layoutSettings.amountInWords && (
                <div
                  className="draggable-item"
                  draggable
                  onDragStart={(e) => handleDragStart(e, "amountInWords")}
                  onDragEnd={handleDragEnd}
                  style={{
                    position: "absolute",
                    left: `${positions.amountInWords.x}px`,
                    top: `${positions.amountInWords.y}px`,
                    cursor: "move",
                    userSelect: "none",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#444",
                    width: "80%",
                    minWidth: "200px"
                  }}
                >
                  {finalAmtInWord}

                </div>
              )}

              {/* Date */}
              {layoutSettings.date && (
                <div
                  className="draggable-item"
                  draggable
                  onDragStart={(e) => handleDragStart(e, "date")}
                  onDragEnd={handleDragEnd}
                  style={{
                    position: "absolute",
                    left: `${positions.date.x}px`,
                    top: `${positions.date.y}px`,
                    cursor: "move",
                    userSelect: "none",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#222",
                    minWidth: "100px"
                  }}
                >
                  {formatDate(currentChequeData.date, dateFormat)}
                </div>
              )}

              {/* Signature */}
              {layoutSettings.signature && signature && (
                <div
                  className="draggable-item"
                  draggable
                  onDragStart={(e) => handleDragStart(e, "signature")}
                  onDragEnd={handleDragEnd}
                  style={{
                    position: "absolute",
                    left: `${positions.signature.x}px`,
                    top: `${positions.signature.y}px`,
                    cursor: "move",
                    userSelect: "none"
                  }}
                >
                  <img
                    src={signature}
                    alt="Signature"
                    style={{
                      width: "60px",
                      height: "40px",
                      objectFit: "contain"
                    }}
                  />
                </div>
              )}

              {/* Logo */}
              {layoutSettings.logo && logo && (
                <div
                  className="draggable-item"
                  draggable
                  onDragStart={(e) => handleDragStart(e, "logo")}
                  onDragEnd={handleDragEnd}
                  style={{
                    position: "absolute",
                    left: `${positions.logo.x}px`,
                    top: `${positions.logo.y}px`,
                    cursor: "move",
                    userSelect: "none"
                  }}
                >
                  <img
                    src={logo}
                    alt="Logo"
                    style={{
                      width: "60px",
                      height: "40px",
                      objectFit: "contain"
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Right Controls Panel */}
        <div className="right-controls-panel" style={{
          background: "#fff",
          border: "1px solid #e1e5e9",
          borderRadius: "12px",
          padding: window.innerWidth <= 768 ? "12px" : "16px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        }}>
          <div className="options-grid" style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <button className="cheque-modern-btn" onClick={testLayout} style={{
              padding: "8px 12px", fontSize: "12px", borderRadius: "6px", border: "1px solid #e1e5e9", background: "#fff", cursor: "pointer"
            }}>
              Test Layout Bulk
            </button>
            <button className="cheque-modern-btn" onClick={testLayout2} style={{
              padding: "8px 12px", fontSize: "12px", borderRadius: "6px", border: "1px solid #e1e5e9", background: "#fff", cursor: "pointer"
            }}>
              Test Layout
            </button>
            <UploadPreview type="logo" />
            <UploadPreview type="signature" />
            <button className="cheque-modern-btn" onClick={updateUserProfile} style={{
              padding: "8px 12px", fontSize: "12px", borderRadius: "6px", border: "1px solid #e1e5e9", background: "#4a5546", color: "#fff", cursor: "pointer"
            }}>
              Update Profile
            </button>
          </div>

          <div className="layout-save-section" style={{ marginTop: "16px", paddingTop: "16px", borderTop: "1px solid #e9ecef" }}>
            <select
              className="cheque-modern-input"
              value={layoutPreferences.currentLayoutName}
              onChange={(e) => {
                const selectedLayout = layoutPreferences.savedLayouts.find(
                  (layout) => layout.layout_name === e.target.value
                );
                if (selectedLayout) {
                  loadSavedLayout(selectedLayout);
                }
              }}
              style={{ width: "100%", marginBottom: "8px", fontSize: "12px", padding: "6px 8px" }}
            >
              <option value="">Select Saved Layout</option>
              {layoutPreferences.savedLayouts.map((layout) => (
                <option key={layout.id} value={layout.layout_name}>
                  {layout.layout_name}
                </option>
              ))}
            </select>

            <input
              className="cheque-modern-input"
              type="text"
              placeholder="Layout Name"
              value={layoutPreferences.currentLayoutName}
              onChange={(e) =>
                setLayoutPreferences((prev) => ({
                  ...prev,
                  currentLayoutName: e.target.value,
                }))
              }
              style={{ width: "100%", marginBottom: "8px", fontSize: "12px", padding: "6px 8px" }}
            />

            <div style={{ display: "flex", gap: "8px" }}>
              {layoutPreferences.currentLayoutName && (
                <button
                  className="delete-layout-btn"
                  onClick={handleDeleteLayout}
                  style={{
                    padding: "6px 8px", fontSize: "12px", borderRadius: "4px", border: "1px solid #dc3545", background: "#fff", color: "#dc3545", cursor: "pointer", flex: "0 0 auto"
                  }}
                >
                  Delete
                </button>
              )}

              <button className="cheque-modern-btn" onClick={saveLayoutPreference} style={{
                padding: "6px 12px", fontSize: "12px", borderRadius: "4px", border: "none", background: "#4a5546", color: "#fff", cursor: "pointer", flex: 1
              }}>
                Save Layout
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bulk Navigation */}
      {bulkPreviewMode && (
        <div className="bulk-navigation" style={{
          position: "fixed",
          bottom: "20px",
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          alignItems: "center",
          gap: "16px",
          background: "#fff",
          padding: "12px 24px",
          borderRadius: "50px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
          border: "1px solid #e1e5e9",
          zIndex: 1000
        }}>
          <button
            className="nav-button"
            onClick={() => handleBulkNavigation("prev")}
            disabled={currentBulkIndex === 0}
            style={{
              padding: "8px 16px",
              borderRadius: "8px",
              border: "1px solid #e1e5e9",
              background: currentBulkIndex === 0 ? "#f8f9fa" : "#fff",
              color: currentBulkIndex === 0 ? "#6c757d" : "#495057",
              cursor: currentBulkIndex === 0 ? "not-allowed" : "pointer",
              fontSize: "14px",
              fontWeight: "500"
            }}
          >
            Previous
          </button>
          <span className="bulk-counter" style={{
            fontSize: "14px",
            fontWeight: "600",
            color: "#495057",
            minWidth: "120px",
            textAlign: "center"
          }}>
            Cheque {currentBulkIndex + 1} of {bulkData.length}
          </span>
          <button
            className="nav-button"
            onClick={() => handleBulkNavigation("next")}
            disabled={currentBulkIndex === bulkData.length - 1}
            style={{
              padding: "8px 16px",
              borderRadius: "8px",
              border: "1px solid #e1e5e9",
              background: currentBulkIndex === bulkData.length - 1 ? "#f8f9fa" : "#fff",
              color: currentBulkIndex === bulkData.length - 1 ? "#6c757d" : "#495057",
              cursor: currentBulkIndex === bulkData.length - 1 ? "not-allowed" : "pointer",
              fontSize: "14px",
              fontWeight: "500"
            }}
          >
            Next
          </button>
          <button
            className="print-all-button"
            onClick={printAllCheques}
            style={{
              padding: "8px 20px",
              borderRadius: "8px",
              border: "none",
              background: "#4a5546",
              color: "#fff",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "600",
              marginLeft: "8px"
            }}
          >
            Print All Cheques
          </button>
        </div>
      )}
    </div>
  );
}